import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import moment from 'moment'

import DateView from './DateView'
import TimeView from './TimeView'
import RecurrenceView from './RecurrenceView'
import FunctionUtils from '../../../../lambda/FunctionUtils'

import '../styles.css'

class DateModule extends React.Component {

  static propTypes = {
    jobInfo: PropTypes.shape().isRequired,
    dateStr: PropTypes.string.isRequired,
    teamId: PropTypes.string.isRequired
  }
  
  constructor(props) {
    super(props)
    this.lastStartDateSelected = moment().format('YYYY-MM-DD')
    this.lastEndDateSelected = moment().format('YYYY-MM-DD')
  }

  getModuleInfo() {
    return this.props.jobInfo.modules.date
  }

  getRecurrence() {
    return this.getModuleInfo().recurrence
  }

  onSaveRecurrence(recurrence) {
    // If is new job then just change the module
    if (this.props.jobInfo.temporal) {
      FunctionUtils.updateModule(this.props.jobInfo, 'modules/date/recurrence',
        recurrence, false)
    }
  }

  render() {
    return (
      <div className="vertical-container">
        <DateView
          jobInfo={this.props.jobInfo}
          dateStr={this.props.dateStr}
          teamId={this.props.teamId}/>
        <TimeView
          jobInfo={this.props.jobInfo} />
        <RecurrenceView
          jobInfo={this.props.jobInfo}
          dateInfo={this.getModuleInfo()}
          dateStr={this.props.dateStr}
          isNewJob={this.props.jobInfo.temporal}
          onSave={this.onSaveRecurrence.bind(this)}/>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    teamId: state.firebase.team.metadata.value.id
  }
}

export default connect(mapStateToProps)(DateModule)



// WEBPACK FOOTER //
// ./src/schedule/common/modules/date/DateModule.js